import removeStudentFromClass from "controllers/class/removeStudentFromClass";
import { confirm } from "util/confirm";
import { alert } from "util/alert";

//
// handle exitclass function in student table
//
// NOTE: 'this' here is bind to a TabComponent (eg. DefaultTab) where unmodified students state is stored.
// 
export default function exitClass ({ classID: classIDToRemove, className }, { schoolStudentID, sName }) {
  confirm(__('Remove "{sName}" From "{className}"?', 'student', { className, sName }), __('Exit Class', 'student'))
    .then(()=>{
      this.setState({
        fetching: true,
      });

      // STEP 2. use controller to call backend
      removeStudentFromClass(classIDToRemove, schoolStudentID)
        .then((res)=>{
          let { studentState } = this.props;
          alert.success(__('The student {student_name} has been removed from the class.', 'student', { student_name: sName }), __('Exit Class Successful', 'student')).then(()=>{
            this.props.student.fetchStudent('after student removed by ctrl @exitClass', studentState);
          });;
        })
        .catch((err)=>{
          console.error(err);
        });
    })
    .catch((err)=>{
      console.error(err);
    });
}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/exit-class.js